export default "__VITE_ASSET__ChyN36GI__"